/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 79757:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(10996);

/***/ }),

/***/ 52256:
/***/ ((module) => {

module.exports = {
  desktop: {
    normal: {
      size: 'q_auto:best'
    },
    withText: {
      size: 'q_auto:best'
    }
  },
  mobile: {
    normal: {
      size: 'q_auto:low'
    },
    withText: {
      size: 'q_auto:low'
    }
  },
  tablet: {
    normal: {
      size: 'q_auto:best'
    },
    withText: {
      size: 'q_auto:low'
    }
  }
};

/***/ }),

/***/ 10996:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var _objectSpread = (__webpack_require__(91903)["default"]);
var _reactJsxRuntime = __webpack_require__(20997);
__webpack_require__(57037);
var React = __webpack_require__(16689);
var _require = __webpack_require__(16689),
  useContext = _require.useContext;
var Variations = __webpack_require__(6996);
var _require2 = __webpack_require__(31901),
  LandingContext = _require2.LandingContext;
var Link = __webpack_require__(97589);
var schema = __webpack_require__(18259);
var Header = function Header(_ref) {
  var index = _ref.index,
    component = _ref.component;
  var _useContext = useContext(LandingContext),
    components = _useContext.landingData.components,
    deviceType = _useContext.landingConfig.deviceType,
    webp = _useContext.webp;
  var json = component || components[index];
  var _json$data = json.data,
    link = _json$data.link,
    label = _json$data.label,
    element_order = _json$data.element_order;
  return /*#__PURE__*/_jsx(Variations, {
    json: json,
    schema: schema,
    render: function render(_ref2) {
      var Variation = _ref2.Variation;
      return /*#__PURE__*/_jsx("section", {}, void 0, /*#__PURE__*/_jsx(Link, {
        link: link,
        label: label,
        element_order: element_order
      }, void 0, /*#__PURE__*/_reactJsxRuntime.jsx(Variation, _objectSpread(_objectSpread({}, json.data), {}, {
        styles: json.styles,
        deviceType: deviceType,
        webp: webp
      }))));
    }
  });
};
Header.defaultProps = {
  component: null
};
module.exports = Header;

/***/ }),

/***/ 18259:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var normalVariation = __webpack_require__(44828);
var withText = __webpack_require__(76379);
module.exports = {
  normal: {
    component: normalVariation
  },
  withText: {
    component: withText
  }
};

/***/ }),

/***/ 44828:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var Image = __webpack_require__(40986);
var imgConfig = __webpack_require__(52256);
var Normal = function Normal(_ref) {
  var imgAlt = _ref.imgAlt,
    section = _ref.section,
    styles = _ref.styles,
    deviceType = _ref.deviceType;
  var bg_color = styles.bg_color,
    bg_mobile = styles.bg_mobile,
    bg_desktop = styles.bg_desktop;
  var isDesktop = deviceType === 'desktop';
  var imgconfig = imgConfig[deviceType].normal;
  return /*#__PURE__*/_jsx("div", {
    style: {
      '--background': bg_color
    },
    className: "hub_section__".concat(section)
  }, void 0, bg_mobile && bg_desktop && /*#__PURE__*/_jsx(Image, {
    alt: imgAlt,
    image: isDesktop ? bg_desktop : bg_mobile,
    imgconfig: imgconfig,
    styles: styles,
    preloadable: true
  }));
};
module.exports = Normal;

/***/ }),

/***/ 76379:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
__webpack_require__(76369);
/* eslint-disable no-prototype-builtins */
/* eslint-disable indent */
var React = __webpack_require__(16689);
var Image = __webpack_require__(40986);
var imgConfig = __webpack_require__(52256);
var WithText = function WithText(_ref) {
  var animated = _ref.animated,
    imgAlt = _ref.imgAlt,
    title = _ref.title,
    subtitle = _ref.subtitle,
    section = _ref.section,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    deviceType = _ref.deviceType;
  var isDesktop = deviceType === 'desktop';
  var bg_color = styles.bg_color,
    bg_mobile = styles.bg_mobile,
    bg_desktop = styles.bg_desktop;
  var imgSrc = isDesktop ? bg_desktop : bg_mobile;
  var getTextStyles = function getTextStyles(textType) {
    var hasStylesForText = styles.hasOwnProperty(deviceType) && styles[deviceType].hasOwnProperty(textType);
    if (styles.hasOwnProperty('text_color')) {
      var textColor = {
        color: styles.text_color
      };
      return hasStylesForText ? Object.assign(styles[deviceType][textType], textColor) : textColor;
    }
    return hasStylesForText ? styles[deviceType][textType] : null;
  };

  // styles[deviceType] for title/subtitle NOT supported on splinter-admin
  var titleStyles = getTextStyles('title');
  var subtitleStyles = getTextStyles('subtitle');
  return /*#__PURE__*/_jsx("div", {
    style: {
      '--background': bg_color
    },
    className: "hub_section__".concat(section, "  with-text")
  }, void 0, bg_desktop && bg_mobile && /*#__PURE__*/_jsx("div", {
    className: "header__image"
  }, void 0, /*#__PURE__*/_jsx(Image, {
    alt: imgAlt,
    image: imgSrc,
    imgconfig: imgConfig[deviceType].withText,
    styles: styles,
    preloadable: true
  })), /*#__PURE__*/_jsx("div", {
    className: "header__container ".concat(animated ? 'fadeInWithTranslate' : null)
  }, void 0, title && /*#__PURE__*/_jsx("h1", {
    className: "header__title",
    style: titleStyles
  }, void 0, title), subtitle && /*#__PURE__*/_jsx("h2", {
    className: "header__subtitle",
    style: subtitleStyles
  }, void 0, subtitle)));
};
module.exports = WithText;

/***/ }),

/***/ 90029:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 91903:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectSpread2");

/***/ }),

/***/ 31901:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/context");

/***/ }),

/***/ 40986:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/image");

/***/ }),

/***/ 97589:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/link");

/***/ }),

/***/ 6996:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/variations");

/***/ }),

/***/ 76369:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.assign.js");

/***/ }),

/***/ 57037:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.string.link.js");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 20997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(79757);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map